let audioContext: AudioContext | null = null
let unlocked = false

function getAudioContext(): AudioContext {
  if (!audioContext) {
    audioContext = new AudioContext()
  }
  return audioContext
}

/** Разблокировать AudioContext по первому пользовательскому жесту. */
export function unlockChatSound(): void {
  if (unlocked) return
  const ctx = getAudioContext()
  if (ctx.state === 'suspended') {
    void ctx.resume()
  }
  unlocked = true
}

if (typeof window !== 'undefined') {
  const unlock = () => {
    unlockChatSound()
    window.removeEventListener('click', unlock)
    window.removeEventListener('keydown', unlock)
  }
  window.addEventListener('click', unlock, { once: true })
  window.addEventListener('keydown', unlock, { once: true })
}

/** Короткий сигнал о входящем сообщении через Web Audio API. */
export function playChatSound(): void {
  try {
    const ctx = getAudioContext()
    if (ctx.state === 'suspended') {
      void ctx.resume()
    }

    const oscillator = ctx.createOscillator()
    const gain = ctx.createGain()

    oscillator.type = 'sine'
    oscillator.frequency.setValueAtTime(880, ctx.currentTime)
    oscillator.frequency.exponentialRampToValueAtTime(660, ctx.currentTime + 0.12)

    gain.gain.setValueAtTime(0.0001, ctx.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.15, ctx.currentTime + 0.02)
    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.2)

    oscillator.connect(gain)
    gain.connect(ctx.destination)

    oscillator.start(ctx.currentTime)
    oscillator.stop(ctx.currentTime + 0.22)
  } catch {
    // Браузер может заблокировать звук без жеста пользователя.
  }
}
